import React, { useState, useEffect } from 'react';
import { ICustomer } from '../../../store/ducks/customers/types';
import { uppercaseOnlyFirstLetter } from '../../../utils/formatStrings';
import CustomerUsers from './CustomerUsers';
import Table from '../../../components/Table';

interface ICustomersTableDataSource {
  key: number;
  customerName: string;
  bp: string;
  cnpj: string;
  hierarchy: string;
  customerAddress: string;
  customer: ICustomer;
}

interface ICustomersTableProps {
  customers: ICustomer[];
}
const CustomersTable: React.FC<ICustomersTableProps> = ({ customers }) => {
  const [originalData, setOriginalData] = useState<ICustomersTableDataSource[]>(
    []
  );

  const getColumns = () => {
    return [
      {
        title: 'Razão social',
        dataIndex: 'customerName',
        sorter: (a: ICustomersTableDataSource, b: ICustomersTableDataSource) =>
          a.customerName.localeCompare(b.customerName),
        render: (text: string, data: ICustomersTableDataSource) => (
          <>
            <strong>{uppercaseOnlyFirstLetter(text)}</strong>
            <br />
            {data.customerAddress}
          </>
        )
      },
      {
        title: 'Nº do cliente',
        dataIndex: 'bp',
        sorter: (a: ICustomersTableDataSource, b: ICustomersTableDataSource) =>
          a.bp < b.bp ? -1 : a.bp > b.bp ? 1 : 0,
        render: (text: string) => <>{text}</>
      },
      {
        title: 'CNPJ',
        dataIndex: 'cnpj',
        sorter: (a: ICustomersTableDataSource, b: ICustomersTableDataSource) =>
          a.cnpj < b.cnpj ? -1 : a.cnpj > b.cnpj ? 1 : 0,
        render: (text: string) => <>{text}</>
      },
      {
        title: 'Hierarquia',
        dataIndex: 'hierarchy',
        sorter: (a: ICustomersTableDataSource, b: ICustomersTableDataSource) =>
          a.hierarchy.localeCompare(b.hierarchy),
        render: (text: string) => <>{text}</>
      }
    ];
  };

  useEffect(() => {
    const data: ICustomersTableDataSource[] = customers.map((customer, idx) => {
      return {
        key: idx,
        customerName: customer.name,
        customerAddress: `${uppercaseOnlyFirstLetter(
          customer.locality.address
        )}, ${uppercaseOnlyFirstLetter(customer.locality.city)} - ${
          customer.locality.state
        }, ${customer.locality.zipCode}`,
        bp: customer.customerId,
        cnpj: customer.taxNumber || ' - ',
        hierarchy: customer.isParentCompany ? 'Conta Crédito' : 'Subsidiária',
        customer: customer
      };
    });

    setOriginalData(data);
  }, [`${customers}`]);

  return (
    <Table
      columns={getColumns()}
      data={originalData}
      hasPagination
      expandedRowRender={(record) => (
        <CustomerUsers customer={record.customer} />
      )}
    />
  );
};

export default CustomersTable;
